<template>
  <div class="row">
    <div class="col-sm-12">
        <div class="xcard">
        <b class="text-primary">Registros por asesor</b>
        <canvas id="chart-area7b"></canvas>
        </div>
    </div> 
  </div> 
</template>
  
  <script> 
  export default {
      data() {
        return { 
          grafico: null,
        };
      },
      methods: {
        async openmodal(data) {  
          
          const da = window.Object.assign([], data);
          const conteoIntereses = {};

          da.forEach(x => {
            let a = x.asesor;
            let nom = a.nombres+' '+a.pri_apellido+' '+a.seg_apellido;
            const nombreInteres = nom;
            if (conteoIntereses[nombreInteres]) {
                     conteoIntereses[nombreInteres]++;
                } else {
                    conteoIntereses[nombreInteres] = 1;
                } 
            }); 

          // window.console.log(data,conteoIntereses);
        if(this.grafico){
            this.grafico.destroy();
        }
          setTimeout(() => {
            this.crearGraficoGeneral(conteoIntereses);
          }, 400);
        }, 
        crearGraficoGeneral(conteoIntereses){ 
            const labeles = Object.keys(conteoIntereses);
            const datas = Object.values(conteoIntereses);
            const maxData = Math.max(...datas) + 0.5;
            
            const colores = ["#cde7f7","#6695bd"];
            for (let i = 0; i < datas.length; i++) {
                const colorIndex = i % colores.length; 
                colores.push(colores[colorIndex]);
            }

            const datosCombinados = datas.map((valor, index) => {
                return {
                    valor: valor,
                    label: labeles[index],
                    color: colores[index]
                };
            });

            datosCombinados.sort((a, b) => b.valor - a.valor);

            const datasOrdenadas = datosCombinados.map(item => item.valor);
            const labelesOrdenadas = datosCombinados.map(item => item.label);

            const config = {
                type: 'horizontalBar',
                data: {
                    datasets: [{ data: datasOrdenadas, backgroundColor: colores, label: 'Grafico General' }],
                    labels: labelesOrdenadas,
                },
                options: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true, 
                                max: maxData,
                                stepSize: 1
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {  
                                var cant = data.datasets[0].data[tooltipItem.index] || '';
                                return cant;
                            },
                        },
                    },
                }, 
                plugins: [{
                    // Plugin para mostrar los labels dentro de las barras
                    afterDatasetsDraw: function(chart) {
                        var ctx = chart.ctx;
                        chart.data.datasets.forEach(function(dataset, i) {
                            var meta = chart.getDatasetMeta(i);
                            meta.data.forEach(function(bar, index) {
                                var data = dataset.data[index];
                                ctx.fillStyle = '#000000'; 
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'middle';
                                ctx.fillText(data, bar._model.x - 15, bar._model.y); // Ajustar posición
                            });
                        });
                    }
                }]
            }; 

            const idcanvas = "chart-area7b"
            var ctx1 = document.getElementById(idcanvas).getContext('2d');
            this.grafico = new window.Chart(ctx1, config);
        },
        
      },
    };
  </script>
  